// https://medium.com/fullstackio/managing-state-in-vue-js-23a0352b1c87
export const store = {
  lastSeenCardNum: null
}